import { render, staticRenderFns } from "./RtRadio.vue?vue&type=template&id=3476f52c&scoped=true&"
import script from "./RtRadio.vue?vue&type=script&lang=ts&"
export * from "./RtRadio.vue?vue&type=script&lang=ts&"
import style0 from "./RtRadio.vue?vue&type=style&index=0&id=3476f52c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3476f52c",
  null
  
)

export default component.exports